import React from "react";
import { Pagination } from "@pd/pd-ui-kit";
import { useTranslation } from "react-i18next";
import { useHistory, useParams } from "react-router-dom";

import DealerInfoPanel from "~/components/DealerInfoPanel";
import Back from "~/components/Icons/arrow-prev2";
import Button from "~/shared/ui/Fields/Button";
import { useChecklistsPage } from "~/pages/Checklists/hooks/useChecklistsPage";
import { getChecklistsColumns } from "~/pages/Checklists/model/tableAdapter";
import { usePaginationParams } from "~/shared/hooks/usePaginationParams";
import { TableV2 } from "~/shared/ui/TableV2";
import { PKDBreadcrams } from "~/widgets/PKDBreadcrams";

import s from "~/pages/Checklists/checklists.less";
interface IParams {
  id: string;
}
const DepartmentCheckList = () => {
  const { t } = useTranslation();
  const { id } = useParams<IParams>();
  const history = useHistory();

  const idsArray = Array.isArray(id)
    ? id
    : id.split(",").map((item) => item.trim());

  const { checklists, total, page, count, handleViewClick } = useChecklistsPage(
    {
      departmentIds: idsArray,
      withAutoCrmidGuard: true,
    },
  );

  const goBack = () => {
    history.replace("/pkd/");
  };

  const { handleCount, handlePage } = usePaginationParams("urlParams");

  return (
    <>
      <div className={s.wrapper}>
        <PKDBreadcrams />
        <div className={s.mb}>
          <div className={s.title}>
            {t(`pkd_checklists.magazine_checklists`)}
          </div>
          <Button txtBtn={t("ui.back")} onClick={goBack} small>
            <Back />
          </Button>
        </div>

        <DealerInfoPanel type="Staff" />
        {checklists.length > 0 && (
          <>
            <TableV2
              columns={getChecklistsColumns(t)}
              dataSource={checklists}
              rowKey="id"
              onRow={(record) => ({
                onClick: () => handleViewClick(record),
              })}
            />
            <Pagination
              count={Number(count) || 25}
              page={(Number(page) || 0) + 1}
              totalCount={total}
              onChangeCount={handleCount}
              onChangePage={handlePage}
            />
          </>
        )}
      </div>
      {checklists.length <= 0 && (
        <div className={`${s.noData}` + " " + `${s.paddingTop}`}>
          {t(`pkd_checklists.no_data`)}
        </div>
      )}
    </>
  );
};

export default DepartmentCheckList;
